export class URLParser {

    static getOrganisationId(url: string): string {
        let urlOid = '';
        if (url[0] === '/') {
            url = url.substring(1);
        }
        const fragments = url.split('/');
        urlOid = fragments[0];
        return urlOid;
    }


}
